// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___1ZhOY","header":"styles__header___3TjjS"};